import React from 'react';
import useStyles from './footer.styled';
import packageInfo from '../../../package.json';
import { Box, Typography } from '@material-ui/core';

const Footer = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography className={classes.copyright}>
        Version {packageInfo.version} © {new Date().getFullYear()}
      </Typography>
    </Box>
  );
};

export default Footer;
